export default __webpack_public_path__ + "static/media/cover-img-1-1.dd757b12.png";